import clsx from 'clsx';
import { ProductListingProps } from 'interfaces/cms/content';
import ProductItemButton from './ProductItemButton';
import ProductItemDefault from './ProductItemDefault';
import ProductItemTwoColumn from './ProductItemTwoColumn';

interface ProductListingAddonProps extends ProductListingProps {
  isMobileTwoCol: boolean;
}
function ProductItem({
  title,
  subtitle,
  titleColor,
  subtitleColor,
  content,
  image,
  button,
  bulletColor,
  isMobileTwoCol,
}: ProductListingAddonProps) {
  return (
    <div
      className={clsx(
        'p-[0.625rem] md:p-[1rem]',
        isMobileTwoCol ? ' bg-white' : 'bg-transparent',
        'rounded-[10px] border-[1px] border-solid flex flex-wrap content-between'
      )}
    >
      {isMobileTwoCol ? (
        <ProductItemTwoColumn
          title={title}
          subtitle={subtitle}
          titleColor={titleColor}
          subtitleColor={subtitleColor}
          content={content}
          image={image}
          bulletColor={bulletColor}
        />
      ) : (
        <ProductItemDefault
          title={title}
          subtitle={subtitle}
          titleColor={titleColor}
          subtitleColor={subtitleColor}
          content={content}
          image={image}
          bulletColor={bulletColor}
        />
      )}
      <ProductItemButton button={button} />
    </div>
  );
}

export default ProductItem;
